<template>
    <div class="">
        <div class="top_title">
            <div class="top_back_home" @click="backToindex">
                <img src="../../../public/images/home.png" alt=""/>
                <p>返回首页</p>
            </div>
            <div class="title">
                客户管理
            </div>
        </div>
        <div class="main">

            <!-- 全系统欠款总览 -->
            <div class="qiankuan_zonglan">
                <div class="title">
                    <div class="left">
                        全系统欠款总览
                    </div>
                </div>
                <div class="qiankuan">
                    <div class="item">
                        <h3>{{ customer }}</h3>
                        <p>总欠款客户数</p>
                    </div>
                    <div class="item">
                        <h3>{{ debt }}</h3>
                        <p>总欠款金额</p>
                    </div>
                    <div class="item">
                        <h3>{{ avg_debt }}</h3>
                        <p>户均欠款</p>
                    </div>
                </div>
                <div class="paiming">
                    <div class="tips">
                        销售员欠款排名
                        <img src="../../../public/images/top5.png" alt=""/>
                    </div>
                    <div class="name_list">
                        <div class="item" v-for="(item, index) in saleList" :key="item.id">
                            <div class="numid">
                                {{ index + 1 }}
                            </div>
                            <div class="name">
                                {{ item.any_sale_name }}
                            </div>
                            <div class="money">
                                {{ item.total_debt }}
                            </div>
                        </div>
                    </div>
                </div>

            </div>

            <div class="tab_title">
                <div v-for="(item, index) in items" :key="item.id" class="item"
                     :class="{ 'active': item.id === activeId }" @click="setActive(item.id)">
                    {{ item.title }}
                </div>
            </div>

            <!-- 客户管理大 -->
            <div class="customer_mingxi" v-if="activeId === 1">
                <div class="salesperson">
                    <div class="title">
                        <div class="left">
                            选择销售员：
                            <el-select v-model="sale_id" @change="changeSelectSale" placeholder="请选择销售员">
                                <el-option v-for="item in allSaleList" :key="item.id" :label="item.name"
                                           :value="item.id">
                                </el-option>
                            </el-select>
                        </div>
                    </div>
                </div>

                <!-- 客户列表 -->
                <div class="sales_man">
                    <div class="title">
                        <div class="left">
                            客户列表
                        </div>
                        <div class="right">
                            <div class="search">
                                <el-input placeholder="客户名称" v-model="customer_name" clearable>
                                    <i slot="prefix" class="el-input__icon el-icon-search"></i>
                                </el-input>
                            </div>
                            <div class="paixu">
                                <el-select v-model="type" placeholder="请选择">
                                    <el-option v-for="item in customerSortList" :key="item.value" :label="item.label"
                                               :value="item.value">
                                    </el-option>
                                </el-select>
                            </div>
                            <div class="shuaxin" @click="getCustomerList(1)">
                                <img src="../../../public/images/shauxin.png" alt="" srcset=""/>
                            </div>
                            <div class="add_customer" @click="addCustomer">
                                <img src="../../../public/images/add.png" alt="" srcset=""/>
                                添加客户
                            </div>
                        </div>
                    </div>
                    <div class="customer_list">
                        <div class="item" v-for="item in customerList">
                            <div class="top">
                                {{ item.name }}
                                <img src="../../../public/images/del.png" @click="delCustomer(item.id)" alt=""
                                     srcset=""/>
                            </div>
                            <div class="bottom">
                                <div class="ll">
                                    <p>欠款金额<span>{{ item.total_debt }}</span></p>
                                    <p>抹零金额<span>{{ item.total_waive }}</span></p>
                                </div>
                                <div class="rr" @click="toCustomerDetails(item.id)">管理</div>
                            </div>
                        </div>

                    </div>
                    <!--                    <div class="pagination">-->
                    <!--                        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"-->
                    <!--                                       :current-page="currentPage4" :page-sizes="[100, 200, 300, 400]" :page-size="100"-->
                    <!--                                       layout="total, sizes, prev, pager, next, jumper" :total="400">-->
                    <!--                        </el-pagination>-->
                    <!--                    </div>-->
                </div>

                <!-- 销售抹零统计 -->
                <div class="sales_man">
                    <div class="title">
                        <div class="left">
                            销售抹零统计
                        </div>
                        <div class="right">
                            <div class="ll">
                                <div @click="selectWaiveDateType(0)"
                                     :class="waiveDateType == 0 ? 'itte active' : 'itte'">
                                    今日
                                </div>
                                <div @click="selectWaiveDateType(1)"
                                     :class="waiveDateType == 1 ? 'itte active' : 'itte'">
                                    本月
                                </div>
                                <div @click="selectWaiveDateType(2)"
                                     :class="waiveDateType == 2 ? 'itte active' : 'itte'">
                                    自定义
                                </div>
                            </div>
                            <div class="cc">
                                <el-date-picker v-model="waiveDaterange" type="daterange" format="yyyy-MM-dd"
                                                value-format="yyyy-MM-dd" range-separator="~"
                                                start-placeholder="开始日期" end-placeholder="结束日期" clearable>
                                </el-date-picker>
                            </div>
                            <div class="shuaxin" @click="getWaiveBySale(1)">
                                <img src="../../../public/images/shauxin.png" alt="" srcset=""/>
                            </div>
                        </div>
                    </div>
                    <div class="ml_money">
                        <div class="zong">
                            总抹零<p>{{ total_waive }}</p>
                        </div>
                        <div class="tong">
                            统计范围抹零<p>{{ range_waive }}</p>
                        </div>
                    </div>
                    <div class="table">
                        <el-table :data="waiveList" style="width: 100%" max-height="280">
                            <el-table-column prop="time" label="抹零记录">
                            </el-table-column>
                            <el-table-column prop="waive_fee" label="抹零金额">
                            </el-table-column>
                        </el-table>
                    </div>
                </div>


            </div>

            <!-- 销售还款统计大 -->
            <div class="huankuan_mingxi" v-if="activeId === 2">
                <div class="salesperson">
                    <div class="title">
                        <div class="left">
                            选择销售员：
                            <el-select v-model="sale_id" @change="changeSelectSale" placeholder="请选择销售员">
                                <el-option v-for="item in allSaleList" :key="item.id" :label="item.name"
                                           :value="item.id">
                                </el-option>
                            </el-select>
                        </div>
                        <div class="right">
                            <div class="ll">
                                <div @click="selectRepaymentDateType(0)"
                                     :class="date_type == 0 ? 'itte active' : 'itte'">
                                    今日
                                </div>
                                <div @click="selectRepaymentDateType(1)"
                                     :class="date_type == 1 ? 'itte active' : 'itte'">
                                    本月
                                </div>
                                <div @click="selectRepaymentDateType(2)"
                                     :class="date_type == 2 ? 'itte active' : 'itte'">
                                    自定义
                                </div>
                            </div>
                            <div class="cc">
                                <el-date-picker v-model="daterange" type="daterange" format="yyyy-MM-dd"
                                                value-format="yyyy-MM-dd" range-separator="~"
                                                start-placeholder="开始日期" end-placeholder="结束日期" clearable>
                                </el-date-picker>
                            </div>
                            <div class="shuaxin" @click="getRepaymentOrderListBySale">
                                <img src="../../../public/images/shauxin.png" alt="" srcset=""/>
                            </div>
                        </div>
                    </div>
                    <div class="salesperson_money">
                        <div class="item">
                            <div class="tt">
                                总还款金额
                                <img src="../../../public/images/money1.png" alt="" srcset=""/>
                            </div>
                            <div class="bb">
                                {{ totalMoney }}
                            </div>
                        </div>
                        <div class="item">
                            <div class="tt">
                                总抹零金额
                                <img src="../../../public/images/money2.png" alt="" srcset=""/>
                            </div>
                            <div class="bb">
                                {{ totalWaive }}
                            </div>
                        </div>
                        <div class="item">
                            <div class="tt">
                                还款订单数
                                <img src="../../../public/images/money3.png" alt="" srcset=""/>
                            </div>
                            <div class="bb">
                                {{ total_num }}
                            </div>
                        </div>
                        <div class="item">
                            <div class="tt">
                                平均每单还款
                                <img src="../../../public/images/money4.png" alt="" srcset=""/>
                            </div>
                            <div class="bb">
                                {{ average }}
                            </div>
                        </div>
                    </div>

                </div>
                <div class="huankuan_order_list">
                    <div class="title">
                        <div class="left">
                            还款订单列表
                        </div>
                        <div class="right">
                            <div class="search">
                                <el-input placeholder="客户名称/商品" v-model="keyword">
                                    <i slot="prefix" class="el-input__icon el-icon-search"></i>
                                </el-input>
                            </div>
                            <div class="paixu">
                                <el-select v-model="repaymentOrderSortType" placeholder="请选择">
                                    <el-option v-for="item in repaymentOrderSortTypeArr" :key="item.value"
                                               :label="item.label"
                                               :value="item.value">
                                    </el-option>
                                </el-select>
                            </div>
                            <div class="shuaxin" @click="getRepaymentOrderListBySale">
                                <img src="../../../public/images/shauxin.png" alt="" srcset=""/>
                            </div>
                        </div>
                    </div>
                    <div class="table">
                        <el-table :data="repaymentOrderList" style="width: 100%">
                            <el-table-column prop="customer_name" label="客户"></el-table-column>
                            <el-table-column prop="time" label="记账时间"></el-table-column>
                            <el-table-column prop="product_name" label="商品"></el-table-column>
                            <el-table-column prop="number" label="数量"></el-table-column>
                            <el-table-column prop="price" label="单价"></el-table-column>
                            <el-table-column prop="total_fee" label="总金额"></el-table-column>
                            <el-table-column prop="back_time" label="还款时间"></el-table-column>
                            <el-table-column prop="repayment_fee" label="还款信息">
                                <template #default="scope">
                                    <div style="color: rgb(103, 194, 58);">已还：{{ scope.row.repayment_fee }}</div>
                                    <div style="color: rgb(230, 162, 60);">抹零：{{ scope.row.waive_fee }}</div>
                                    <div style="color: rgb(245, 108, 108);">剩余：{{ scope.row.surplus_fee }}</div>
                                </template>
                            </el-table-column>
                            <el-table-column label="状态" prop="tag">
                                <template #default="scope">
                                    <el-tag v-if="scope.row.is_back == 1" disable-transitions size="mini" type="danger">
                                        未还款
                                    </el-tag>
                                    <el-tag v-if="scope.row.is_back == 2" disable-transitions size="mini"
                                            type="success">
                                        已还款
                                    </el-tag>
                                    <el-tag v-if="scope.row.is_back == 3" disable-transitions size="mini"
                                            type="warning">
                                        部分还款
                                    </el-tag>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                    <div class="pagination">
                        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                                       :current-page="currentPage" :page-sizes="[10, 20, 50, 100]"
                                       :page-size="page_size"
                                       layout="total, sizes, prev, pager, next, jumper" :total="totalListNum">
                        </el-pagination>
                    </div>
                </div>
            </div>

            <!-- 添加客户弹窗 -->
            <div v-if="showDialogAddCustomer" class="dialog-overlay">
                <div class="dialog-content">
                    <div class="dialog-header">
                        添加客户
                        <img @click="closeDialogAddCustomer" src="../../../public/images/close.png" alt=""/>
                    </div>
                    <div class="dialog-body">
                        <div class="item">
                            <div class="title">
                                绑定销售员名称<span>*</span>
                            </div>
                            <div class="con">
                                <el-select v-model="customerData.sale_id" placeholder="请选择销售员">
                                    <el-option v-for="item in allSaleList" :key="item.id" :label="item.name"
                                               :value="item.id">
                                    </el-option>
                                </el-select>
                            </div>
                        </div>
                        <div class="item">
                            <div class="title">
                                客户名称<span>*</span>
                            </div>
                            <div class="con">
                                <el-input v-model="customerData.name" clearable></el-input>
                            </div>
                        </div>
                        <div class="item">
                            <div class="title">
                                手机号<span></span>
                            </div>
                            <div class="con">
                                <el-input v-model="customerData.phone" clearable></el-input>
                            </div>
                        </div>
                        <div class="item">
                            <div class="title">
                                备注<span></span>
                            </div>
                            <div class="con">
                                <el-input v-model="customerData.remark" clearable></el-input>
                            </div>
                        </div>
                        <div class="control">
                            <div class="itt quxiao" @click="closeDialogAddCustomer">
                                取消
                            </div>
                            <div class="itt sure" @click="sureAddCustomer">
                                确认
                            </div>
                        </div>
                    </div>
                </div>
            </div>


        </div>
    </div>
</template>

<script name="customer">
import router from "@/router";

export default {
    name: 'customer',
    data() {
        return {
            activeId: 1, // 当前激活的元素 ID
            items: [{
                id: 1,
                title: '客户管理'
            },
                {
                    id: 2,
                    title: '销售还款统计'
                }
            ],

            avg_debt: '', // 平均欠款
            customer: '', // 欠款客户数量
            debt: '', // 总欠款
            saleList: [], //欠款销售员排行
            allSaleList: [], // 所有销售员
            sale_id: '',
            //添加客户
            showDialogAddCustomer: false,
            customerData: {
                sale_id: '',
                name: '',
                phone: '',
                remark: '',
            },
            customerList: [],
            customer_name: '',
            type: 0,

            //销售抹零统计
            waiveDateType: 0,
            waiveDaterange: '',
            total_waive: '',
            range_waive: '',
            waiveList: [],

            // 销售还款
            totalMoney: '',
            totalWaive: '',
            total_num: '',
            average: '',
            date_type: 0,
            daterange: '',
            repaymentOrderSortTypeArr: [
                {
                    value: 0,
                    label: '还款时间'
                },
                {
                    value: 1,
                    label: '还款金额'
                }, {
                    value: 2,
                    label: '订单时间'
                },
            ],
            repaymentOrderSortType: 0,
            keyword: '',
            repaymentOrderList: [],

            //排序
            customerSortList: [
                {
                    value: 0,
                    label: '按欠款排序'
                }, {
                    value: 1,
                    label: '按时间排序'
                }
            ],
            value: '',
            //分页
            currentPage: 1, //当前页
            page_size: 10, // 每页数量
            totalListNum: 0, // 总数

            // 新增：记录上一页来源
            prevPath: ''
        }
    },

    mounted() {
        this.getDebtStatistics();
    },
    // 路由守卫：记录从哪里来
    beforeRouteEnter(to, from, next) {
        next(vm => {
            vm.prevPath = from.fullPath;
        })
    },
    activated() {
        console.log('返回页面，上一页：', this.prevPath);
        // 判断：从客户详情页返回 → 刷新数据
        if (!this.prevPath.startsWith('/customer_details')) {
            console.log('其他页面返回 → 刷新列表');
            this.getDebtStatistics();
        } else {
            console.log('从详情页返回 → 不刷新');
        }
    },
    deactivated() {
        console.log('页面失活')
    },
    methods: {
        //返回首页
        "backToindex"() {
            this.$router.push({
                "path": '/',
            })
        },
        //点击切换
        "setActive"(id) {
            if (id != this.activeId) {
                this.activeId = id;
                if (id == 1) {
                    this.getDebtStatistics();
                } else {
                    this.getRepaymentOrderListBySale();
                }
            }

        },
        "getDebtStatistics"() {
            const loading = this.$loading({
                "lock": true,
                "text": '',
                "spinner": 'el-icon-loading',
                "background": 'rgba(0, 0, 0, 0.7)'
            });
            this.$http.get('/sale/getSaleDebt').then(res => {
                loading.close();
                if (res.data.code == 0) {
                    this.customer = res.data.data.customer;
                    this.debt = res.data.data.debt;
                    this.avg_debt = res.data.data.avg_debt;
                    this.saleList = res.data.data.saleList;
                    this.allSaleList = res.data.data.allSaleList;
                    if (res.data.data.allSaleList.length > 0) {
                        if ((+this.sale_id) <= 0) {
                            this.sale_id = res.data.data.allSaleList[0].id;
                        }
                        this.getCustomerList(0);
                        this.getWaiveBySale(0);
                    }
                } else {
                    this.$message({
                        "type": 'error',
                        "message": res.data.msg
                    })
                }
            });
        },
        // 改变选择销售员
        "changeSelectSale"() {
            if (this.activeId == 1) {
                // 获取客户列表
                this.getCustomerList(1);
                // 获取销售抹零
                this.getWaiveBySale(0);
            } else {
                // 获取销售员还款信息
                this.getRepaymentOrderListBySale();
            }

        },


        "handleClick"(row) {
            console.log('删除行:', row);
        },
        "handleClose"(done) {
            this.$confirm('确认关闭？')
                .then(_ => {
                    done();
                })
                .catch(_ => {
                });
        },
        //分页
        "handleSizeChange"(val) {
            this.page_size = val;
            this.getRepaymentOrderListBySale();
        },
        "handleCurrentChange"(val) {
            this.currentPage = val;
            this.getRepaymentOrderListBySale();
        },
        // 获取客户列表
        "getCustomerList"(isShow = 1) {
            if ((+this.sale_id) <= 0) {
                this.$message({
                    "type": '请先选择销售员',
                    "message": res.data.msg
                })
                return false;
            }
            var loading;
            if (isShow == 1) {
                loading = this.$loading({
                    "lock": true,
                    "text": '',
                    "spinner": 'el-icon-loading',
                    "background": 'rgba(0, 0, 0, 0.7)'
                });
            }
            this.$http.post('/customer/getCustomerListByDebt', {
                "sale_id": this.sale_id,
                "customer_name": this.customer_name,
                "type": this.type,
            }).then(res => {
                if (isShow == 1) {
                    loading.close();
                }
                if (res.data.code == 0) {
                    this.customerList = res.data.data;
                } else {
                    this.$message({
                        "type": 'error',
                        "message": res.data.msg
                    })
                }
            });
        },
        // 添加客户弹窗
        "addCustomer"() {
            this.customerData = {
                "sale_id": '',
                "name": '',
                "phone": '',
                "remark": '',
            };
            this.showDialogAddCustomer = true;
        },
        "closeDialogAddCustomer"() {
            this.showDialogAddCustomer = false;
        },
        "sureAddCustomer"() {
            if ((+this.customerData.sale_id) <= 0) {
                this.$message({
                    "type": '请先选择销售员',
                    "message": res.data.msg
                })
                return false;
            }
            var loading = this.$loading({
                "lock": true,
                "text": '',
                "spinner": 'el-icon-loading',
                "background": 'rgba(0, 0, 0, 0.7)'
            });
            this.$http.post('/customer/edit', this.customerData).then(res => {
                loading.close();
                if (res.data.code == 0) {
                    this.$message({
                        "message": "客户信息保存成功！",
                        "type": "success",
                    });
                    this.closeDialogAddCustomer();
                    this.getCustomerList(1);
                } else {
                    this.$message({
                        "type": 'error',
                        "message": res.data.msg
                    })
                }
            });
        },
        "delCustomer"(id) {
            this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
                "confirmButtonText": '确定',
                "cancelButtonText": '取消',
                "type": 'warning'
            }).then(() => {
                const loading = this.$loading({
                    "lock": true,
                    "text": '',
                    "spinner": 'el-icon-loading',
                    "background": 'rgba(0, 0, 0, 0.7)'
                });
                this.$http.post('/customer/delete', {
                    "id": id,
                }).then(res => {
                    loading.close();
                    if (res.data.code == 0) {
                        this.$message({
                            "message": "操作成功",
                            "type": "success",
                        });
                        this.getCustomerList(1);
                    } else {
                        this.$message({
                            "type": 'error',
                            "message": res.data.msg
                        })
                    }
                });
            }).catch(() => {

            });
        },
        //客户管理详情
        "toCustomerDetails"(id) {
            this.$router.push({
                "path": '/customer_details?id=' + id,
            })
        },

        // 切换抹零筛选时间类型
        "selectWaiveDateType"(type) {
            if (type != this.waiveDateType) {
                this.waiveDateType = type;
                if (type != 2) {
                    this.getWaiveBySale(1);
                }
            }
        },
        // 销售员抹零
        "getWaiveBySale"(isShow = 1) {
            if ((+this.sale_id) <= 0) {
                this.$message({
                    "type": 'error',
                    "message": '请先选择销售员',
                })
                return false;
            }
            if (this.waiveDateType == 2) {
                if (!Array.isArray(this.waiveDaterange)) {
                    this.$message({
                        "type": 'error',
                        "message": '请选择时间范围',
                    })
                    return false;
                }
            }
            var loading;
            if (isShow == 1) {
                loading = this.$loading({
                    "lock": true,
                    "text": '',
                    "spinner": 'el-icon-loading',
                    "background": 'rgba(0, 0, 0, 0.7)'
                });
            }
            this.$http.post('/order/getWaiveBySale', {
                "sale_id": this.sale_id,
                "waiveDateType": this.waiveDateType,
                "waiveDaterange": this.waiveDaterange,
            }).then(res => {
                if (isShow == 1) {
                    loading.close();
                }
                if (res.data.code == 0) {
                    this.waiveList = res.data.data.waiveList;
                    this.total_waive = res.data.data.total_waive;
                    this.range_waive = res.data.data.range_waive;
                } else {
                    this.$message({
                        "type": 'error',
                        "message": res.data.msg
                    })
                }
            });
        },

        // 销售员还款
        getRepaymentOrderListBySale() {
            if ((+this.sale_id) <= 0) {
                this.$message({
                    "type": 'error',
                    "message": '请先选择销售员',
                })
                return false;
            }
            if (this.date_type == 2) {
                if (!Array.isArray(this.daterange)) {
                    this.$message({
                        "type": 'error',
                        "message": '请选择时间范围',
                    })
                    return false;
                }
            }
            var loading = this.$loading({
                "lock": true,
                "text": '',
                "spinner": 'el-icon-loading',
                "background": 'rgba(0, 0, 0, 0.7)'
            });
            this.$http.post('/order/getRepaymentOrderListBySale', {
                "sale_id": this.sale_id,
                "date_type": this.date_type,
                "daterange": this.daterange,
                "keyword": this.keyword,
                "repaymentOrderSortType": this.repaymentOrderSortType,
                'page': this.currentPage,
                'page_size': this.page_size,
            }).then(res => {
                loading.close();
                if (res.data.code == 0) {
                    this.totalMoney = res.data.data.totalMoney;
                    this.totalWaive = res.data.data.totalWaive;
                    this.total_num = res.data.data.total;
                    this.average = res.data.data.average;
                    // 分页数据
                    this.repaymentOrderList = res.data.data.list.data;
                    this.currentPage = res.data.data.list.current_page;
                    this.totalListNum = res.data.data.list.total;
                } else {
                    this.$message({
                        "type": 'error',
                        "message": res.data.msg
                    })
                }
            });
        },
        // 切换日期筛选类型
        selectRepaymentDateType(type) {
            if (type != this.date_type) {
                this.date_type = type;
                if (type != 2) {
                    this.getRepaymentOrderListBySale();
                }
            }
        },
    }
}
</script>

<style lang="less" scoped>
.main {
    padding: 0 20px;
    box-sizing: border-box;

    .qiankuan_zonglan {
        background: #FFFFFF;
        border-radius: 8px 8px 8px 8px;
        padding: 20px;
        margin-bottom: 20px;

        .title {
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-bottom: 12px;

            .left {
                font-family: PingFang SC, PingFang SC;
                font-weight: 500;
                font-size: 18px;
                color: #36363A;
                line-height: 28px;
                padding-left: 8px;
                position: relative;
            }

            .left::after {
                content: '';
                display: block;
                position: absolute;
                left: 0;
                top: 5px;
                width: 4px;
                height: 18px;
                background: #3F72FF;
                border-radius: 12px 12px 12px 12px;
            }

            .right {
                display: flex;
                align-items: center;
                font-family: PingFang SC, PingFang SC;
                font-weight: 400;
                font-size: 14px;
                color: #3D3D3D;

                p {
                    font-family: DIN, DIN;
                    font-weight: 500;
                    font-size: 18px;
                    color: #3D3D3D;
                }
            }
        }

        .qiankuan {
            display: flex;
            align-items: center;
            background: #F5F6FC;
            margin-bottom: 12px;
            padding: 8px 0;

            .item {
                flex: 1;
                display: flex;
                align-items: center;
                justify-content: center;
                flex-direction: column;

                h3 {
                    font-family: DIN, DIN;
                    font-weight: 500;
                    font-size: 32px;
                    color: #333;
                    line-height: 48px;
                }

                p {
                    font-family: PingFang SC, PingFang SC;
                    font-weight: 400;
                    font-size: 14px;
                    color: #4A5676;
                }
            }

            .item:first-child {
                h3 {
                    color: #3F72FF;
                }
            }

            .item:nth-child(2) {
                h3 {
                    color: #FF7700;
                }
            }

            .item:last-child {
                h3 {
                    color: #389F0D;
                }
            }
        }

        .paiming {
            margin-top: 12px;

            .tips {
                display: flex;
                align-items: center;
                font-family: HarmonyOS Sans SC, HarmonyOS Sans SC;
                font-weight: 400;
                font-size: 14px;
                color: #36363A;

                img {
                    display: block;
                    height: 18px;
                    margin-left: 6px;
                }
            }

            .name_list {
                .item {
                    display: flex;
                    align-items: center;
                    font-family: PingFang SC, PingFang SC;
                    font-weight: 400;
                    font-size: 14px;
                    color: #4E5969;
                    line-height: 30px;

                    .name {
                        flex: 1;
                        padding: 0 10px;
                        box-sizing: border-box;
                    }

                    .money {
                        color: #1D2129;
                    }
                }
            }
        }

    }

    .tab_title {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 20px 0px;

        .item {
            flex: 0 0 48%;
            font-family: PingFang SC, PingFang SC;
            font-weight: 500;
            font-size: 20px;
            color: #3F72FF;
            line-height: 50px;
            cursor: pointer;
            border-radius: 50px;
            border: 1px solid #3F72FF;
            text-align: center;
            box-sizing: border-box;
        }

        .item.active {
            color: #fff;
            position: relative;
            background: #3F72FF;
            border: 1px solid #3F72FF;
        }

        .item.active::after {
            //content: '';
            //display: block;
            //position: absolute;
            //left: 50%;
            //bottom: -10px;
            //transform: translate(-50%, 0);
            //width: 25px;
            //height: 5px;
            //background: #3F72FF;
        }
    }


    .salesperson {
        background: #FFFFFF;
        border-radius: 8px 8px 8px 8px;
        padding: 20px;
        margin-bottom: 20px;

        .title {
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-bottom: 16px;

            .left {
                font-family: PingFang SC, PingFang SC;
                font-weight: 500;
                font-size: 18px;
                color: #36363A;
                line-height: 28px;
                padding-left: 8px;
                position: relative;
                display: flex;
                align-items: center;

                .ll {
                    display: flex;
                    align-items: center;
                    font-family: PingFang SC, PingFang SC;
                    font-weight: 400;
                    font-size: 14px;
                    color: #3D3D3D;

                    span {
                        font-family: DIN, DIN;
                        font-weight: 500;
                        font-size: 18px;
                        color: #3D3D3D;
                    }
                }
            }

            .left::after {
                content: '';
                display: block;
                position: absolute;
                left: 0;
                top: 11px;
                width: 4px;
                height: 18px;
                background: #3F72FF;
                border-radius: 12px 12px 12px 12px;
            }

            .right {
                display: flex;
                align-items: center;

                .ll {
                    display: flex;
                    align-items: center;

                    .itte {
                        background: #F5F6FC;
                        border-radius: 3px 3px 3px 3px;
                        font-family: PingFang SC, PingFang SC;
                        font-weight: 400;
                        font-size: 14px;
                        color: #4A5676;
                        line-height: 30px;
                        padding: 0 12px;
                        margin-right: 8px;
                        cursor: pointer;
                    }

                    .itte.active {
                        background: #3F72FF;
                        color: #fff;
                    }
                }

                .shuaxin {
                    margin-left: 8px;
                    cursor: pointer;

                    img {
                        display: block;
                        width: 20px;
                        height: 20px;
                    }
                }

                .search {
                    margin-right: 12px;
                }

                .paixu {
                    margin-right: 4px;
                }

                .shuaxin {
                    margin-left: 8px;
                    cursor: pointer;

                    img {
                        display: block;
                        width: 20px;
                        height: 20px;
                    }
                }

                .add_customer {
                    display: flex;
                    align-items: center;
                    font-family: PingFang SC, PingFang SC;
                    font-weight: 400;
                    font-size: 16px;
                    color: #3F72FF;
                    margin-left: 12px;
                    cursor: pointer;

                    img {
                        display: block;
                        width: 20px;
                        height: 20px;
                    }
                }
            }
        }

        .salesperson_money {
            width: 100%;
            display: flex;
            align-items: center;

            .item {
                flex: 0 0 22%;
                margin-right: 3%;
                background: #fff;
                border-radius: 8px 8px 8px 8px;
                padding: 16px;
                box-sizing: border-box;

                .tt {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    font-family: PingFang SC, PingFang SC;
                    font-weight: 400;
                    font-size: 14px;
                    color: #333;
                    line-height: 22px;

                    img {
                        display: block;
                        width: 20px;
                        height: 20px;
                    }
                }

                .bb {
                    font-family: DIN, DIN;
                    font-weight: 500;
                    font-size: 24px;
                    color: #3F72FF;
                    line-height: 32px;
                }
            }

            .item:first-child {
                background: #F5F6FC;

                .bb {
                    color: #3F72FF;
                }
            }

            .item:nth-child(2) {
                background: #FFFBEF;

                .bb {
                    color: #FFCC00;
                }
            }

            .item:nth-child(3) {
                background: #FCF5F5;

                .bb {
                    color: #FF4D4F;
                }
            }

            .item:last-child {
                margin-right: 0;
                background: #F5FCF5;

                .bb {
                    color: #389F0D;
                }
            }
        }

        .table {
            .actions {
                width: 100%;
                border-radius: 4px 4px 4px 4px;
                border: 1px dashed #C1D0FB;
                text-align: center;
                margin-top: 8px;

                .el-button {
                    margin: 0 auto;
                    border: 0;
                    padding: 0;
                    line-height: 40px;
                    height: 40px;
                    width: 100%;
                    display: block;
                    font-family: PingFang SC, PingFang SC;
                    font-weight: 400;
                    font-size: 16px;
                    color: #3F72FF;
                }
            }
        }
    }

    .huankuan_order_list {
        background: #FFFFFF;
        border-radius: 8px 8px 8px 8px;
        padding: 20px;
        margin-bottom: 20px;

        .title {
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-bottom: 16px;

            .left {
                font-family: PingFang SC, PingFang SC;
                font-weight: 500;
                font-size: 18px;
                color: #36363A;
                line-height: 28px;
                padding-left: 8px;
                position: relative;
                display: flex;
                align-items: center;

                .ll {
                    display: flex;
                    align-items: center;
                    font-family: PingFang SC, PingFang SC;
                    font-weight: 400;
                    font-size: 14px;
                    color: #3D3D3D;

                    span {
                        font-family: DIN, DIN;
                        font-weight: 500;
                        font-size: 18px;
                        color: #3D3D3D;
                    }
                }
            }

            .left::after {
                content: '';
                display: block;
                position: absolute;
                left: 0;
                top: 5px;
                width: 4px;
                height: 18px;
                background: #3F72FF;
                border-radius: 12px 12px 12px 12px;
            }

            .right {
                display: flex;
                align-items: center;

                .ll {
                    display: flex;
                    align-items: center;

                    .itte {
                        background: #F5F6FC;
                        border-radius: 3px 3px 3px 3px;
                        font-family: PingFang SC, PingFang SC;
                        font-weight: 400;
                        font-size: 14px;
                        color: #4A5676;
                        line-height: 30px;
                        padding: 0 12px;
                        margin-right: 8px;
                        cursor: pointer;
                    }

                    .itte.active {
                        background: #3F72FF;
                        color: #fff;
                    }
                }

                .search {
                    margin-right: 12px;
                }
            }
        }

        .table {
            .actions {
                width: 100%;
                border-radius: 4px 4px 4px 4px;
                border: 1px dashed #C1D0FB;
                text-align: center;
                margin-top: 8px;

                .el-button {
                    margin: 0 auto;
                    border: 0;
                    padding: 0;
                    line-height: 40px;
                    height: 40px;
                    width: 100%;
                    display: block;
                    font-family: PingFang SC, PingFang SC;
                    font-weight: 400;
                    font-size: 16px;
                    color: #3F72FF;
                }
            }
        }

        .pagination {
            margin-top: 16px;

            .el-pagination {
                display: flex;
                align-items: center;
                justify-content: flex-end;
            }
        }
    }

    .sales_man {
        background: #FFFFFF;
        border-radius: 8px 8px 8px 8px;
        padding: 20px;
        margin-bottom: 20px;

        .title {
            display: flex;
            align-items: center;
            justify-content: space-between;

            .left {
                font-family: PingFang SC, PingFang SC;
                font-weight: 500;
                font-size: 18px;
                color: #36363A;
                line-height: 28px;
                padding-left: 8px;
                position: relative;
            }

            .left::after {
                content: '';
                display: block;
                position: absolute;
                left: 0;
                top: 5px;
                width: 4px;
                height: 18px;
                background: #3F72FF;
                border-radius: 12px 12px 12px 12px;
            }

            .right {
                display: flex;
                align-items: center;

                .ll {
                    display: flex;
                    align-items: center;

                    .itte {
                        background: #F5F6FC;
                        border-radius: 3px 3px 3px 3px;
                        font-family: PingFang SC, PingFang SC;
                        font-weight: 400;
                        font-size: 14px;
                        color: #4A5676;
                        line-height: 30px;
                        padding: 0 12px;
                        margin-right: 8px;
                        cursor: pointer;
                    }

                    .itte.active {
                        background: #3F72FF;
                        color: #fff;
                    }
                }

                .shuaxin {
                    margin-left: 8px;
                    cursor: pointer;

                    img {
                        display: block;
                        width: 20px;
                        height: 20px;
                    }
                }

                .search {
                    margin-right: 12px;
                }

                .paixu {
                    margin-right: 4px;
                }

                .shuaxin {
                    margin-left: 8px;
                    cursor: pointer;

                    img {
                        display: block;
                        width: 20px;
                        height: 20px;
                    }
                }

                .add_customer {
                    display: flex;
                    align-items: center;
                    font-family: PingFang SC, PingFang SC;
                    font-weight: 400;
                    font-size: 16px;
                    color: #3F72FF;
                    margin-left: 12px;
                    cursor: pointer;

                    img {
                        display: block;
                        width: 20px;
                        height: 20px;
                    }
                }
            }
        }

        .customer_list {
            display: flex;
            flex-wrap: wrap;
            margin-top: 16px;

            .item {
                flex: 0 0 23%;
                margin-right: 2%;
                background: #FFFFFF;
                box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.08);
                border-radius: 8px 8px 8px 8px;
                padding: 12px;
                box-sizing: border-box;
                margin-bottom: 16px;

                .top {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    font-family: PingFang SC, PingFang SC;
                    font-weight: 500;
                    font-size: 16px;
                    color: #3D3D3D;
                    line-height: 24px;
                    padding-bottom: 8px;
                    border-bottom: 1px solid #F0F0F0;

                    img {
                        display: block;
                        width: 16px;
                        height: 16px;
                    }
                }

                .bottom {
                    padding-bottom: 4px;
                    display: flex;
                    align-items: flex-end;
                    justify-content: space-between;

                    .ll {
                        flex: 1;

                        p {
                            display: flex;
                            line-height: 22px;
                            margin-top: 4px;
                            font-family: PingFang SC, PingFang SC;
                            font-weight: 400;
                            font-size: 14px;
                            color: #9B9CA1;
                            line-height: 22px;

                            span {
                                color: #4A5676;
                                margin-left: 8px;
                            }
                        }
                    }


                    .rr {
                        background: #3F72FF;
                        color: #fff;
                        padding: 3px 7px;
                        border-radius: 3px;
                        cursor: pointer;
                    }
                }
            }

            .item:nth-child(4n) {
                margin-right: 0;
            }
        }

        .pagination {
            .el-pagination {
                display: flex;
                align-items: center;
                justify-content: flex-end;
            }
        }

        .ml_money {
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 12px 0;

            .zong {
                flex: 0 0 48%;
                display: flex;
                align-items: center;
                justify-content: center;
                background: #F5F6FC;
                border-radius: 8px 8px 8px 8px;
                font-family: PingFang SC, PingFang SC;
                font-weight: 400;
                font-size: 14px;
                color: #4A5676;
                line-height: 52px;

                p {
                    font-family: DIN, DIN;
                    font-weight: 500;
                    font-size: 24px;
                    color: #3F72FF;
                    margin-left: 12px;
                }
            }

            .tong {
                flex: 0 0 50%;
                display: flex;
                align-items: center;
                justify-content: center;
                background: #F5FCF5;
                border-radius: 8px 8px 8px 8px;
                font-family: PingFang SC, PingFang SC;
                font-weight: 400;
                font-size: 14px;
                color: #4A5676;
                line-height: 52px;

                p {
                    font-family: DIN, DIN;
                    font-weight: 500;
                    font-size: 24px;
                    color: #389F0D;
                    margin-left: 12px;
                }
            }
        }
    }


    .dialog-overlay {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: rgba(0, 0, 0, 0.5);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 2000;

        .dialog-content {
            background: white;
            border-radius: 8px;
            width: 80%;
            max-width: 90%;
            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
            padding: 24px;

            .dialog-header {
                display: flex;
                justify-content: space-between;
                align-items: center;
                font-family: PingFang SC, PingFang SC;
                font-weight: 500;
                font-size: 18px;
                color: #4A5676;
                margin-bottom: 26px;

                img {
                    display: block;
                    width: 24px;
                    height: 24px;
                    cursor: pointer;
                }
            }

            .dialog-body {
                .item {
                    margin-bottom: 20px;

                    .title {
                        display: flex;
                        align-items: center;
                        font-family: PingFang SC, PingFang SC;
                        font-weight: 400;
                        font-size: 16px;
                        color: #36363A;
                        margin-bottom: 12px;

                        span {
                            color: #CB2D18;
                        }
                    }

                    .con {
                        .el-select {
                            width: 100%;
                        }
                    }
                }

                .control {
                    display: flex;
                    align-items: center;
                    justify-content: flex-end;
                    margin-top: 20px;

                    .itt {
                        width: 96px;
                        height: 40px;
                        border-radius: 4px 4px 4px 4px;
                        box-sizing: border-box;
                        line-height: 40px;
                        font-family: PingFang SC, PingFang SC;
                        font-weight: 400;
                        font-size: 16px;
                        text-align: center;
                        margin-left: 16px;
                        cursor: pointer;
                    }

                    .quxiao {
                        border: 1px solid #E5E5E7;
                        color: #36363A;

                    }

                    .sure {
                        background: #3F72FF;
                        border: 1px solid #3F72FF;
                        color: #FFFFFF;
                    }
                }
            }
        }
    }


}
</style>
